import { isAndroid, isIos, isWeb } from "./platform";
import * as validators from "./validators";

const ONE_DAY_TIMESTAMP = 1 * 24 * 60 * 60 * 1000;

export { ONE_DAY_TIMESTAMP, isAndroid, isIos, isWeb, validators };
